// extracted by mini-css-extract-plugin
export default {"pageArea":"Home_pageArea__IUVcV","fullWidth":"Home_fullWidth__-dgLB","hidden":"Home_hidden__jVifY"};